import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Anchor from 'components/Anchor';
import Image from 'components/Image';

import TopbarSearch from '../TopbarSearch';
import NavigationRight from './NavigationRight';
import TopbarBottom from './TopbarBottom';

import APP from 'constants/app';
import IMAGE from 'constants/image';
import LINKS from 'constants/links';

const TopbarDesktop = ({ gaEventCategory }) => (
  <div className="relative z-40 mb-0 hidden w-full items-start border-b border-neutral-high-200 bg-neutral-high-100 px-4 pb-2 pt-4 shadow-md transition-[bottom] duration-300 ease-in dark:border-neutral-low-300 dark:bg-neutral-low-500 lg:flex lg:flex-col">
    <div className="flex w-full max-w-screen-3xl items-center 3xl:mx-auto">
      <div className="flex w-full min-w-0 flex-1 flex-col items-start justify-between gap-y-3">
        <div className="flex w-full items-center">
          <NextLink href={LINKS.HOME} prefetch={false} passHref>
            <Anchor>
              <Image
                alt="Promobit"
                className="h-8 w-[175px] dark:brightness-0 dark:invert"
                height={28}
                loading={null}
                sizes="(max-width: 1024px) 1px, 140px"
                src={IMAGE.LOGO_PATH}
                srcSet={`${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w, ${IMAGE.LOGO_PATH} 140w`}
                width={148}
                priority
              />
            </Anchor>
          </NextLink>
          <TopbarSearch
            className="ml:pl-8 mx-6 h-10 w-full min-w-[280px]"
            gaEventCategory={gaEventCategory}
            id="search-topbar"
          />
        </div>
        <TopbarBottom gaEventCategory={gaEventCategory} />
      </div>
      <NavigationRight gaEventCategory={gaEventCategory} />
    </div>
  </div>
);

TopbarDesktop.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default TopbarDesktop;
